export class ArrayContainsValueBaseValueConverter {
    toView(array, value) {
        return array.indexOf(value) >= 0
    }
}